import { STATUS_ACTIVE, STATUS_NOT_ACTIVE, STATUS_ONBOARDING } from "../Constants";

export default function sort(msisdns)
    {
        const sorted = [...msisdns]
        function findWeightForStatus(status)
        {
            return weights.find(w => w.status === status).weight;
        }

        const weights = [
            {
                status: STATUS_ACTIVE,
                weight: 10
            },
            {
                status: STATUS_ONBOARDING,
                weight: 5
            }, 
            {
                status: STATUS_NOT_ACTIVE,
                weight: 1
            }
        ]

        return sorted.sort((a,b) => {
            const weightA = findWeightForStatus(a.status)
            const weightB = findWeightForStatus(b.status)

            if (weightA < weightB) {
                return 1;
            }
            if (weightA > weightB) {
                return -1;
            }
            // If status values are the same, sort by id
            return a.id - b.id;
        });
    }